import styled from 'styled-components';

const StyledMultipleListChartWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #ffffff;
  padding: 10px;
`;

const StyledMultipleListChartSvg = styled.svg`
  z-index: 1;
`;

const StyledMultipleListChartContent = styled.div`
  height: 100%;
  overflow: hidden auto;
`;

const StyledMultipleListChartMetric = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: rgb(148, 147, 166);
  margin-right: 10px;
  text-align: end;
`;

const StyledMultipleListItem = styled.div`
  width: 100%;
  height: 95px;
  padding-top: 10px;
  border-bottom: 1px solid #cdcdcd;
  position: relative;
`;

const StyledMultipleListItemContent = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
`;

const StyledMultipleListItemTitle = styled.div`
  width: 30%;
  display: flex;
  align-items: left;
  flex-direction: column;
  padding-left: 10px;
  font-size: 16px;
  font-weight: 500;
  color: rgb(148, 147, 166);
`;

const StyledMultipleListItemValue = styled.div<any>`
  width: 30%;
  display: flex;
  align-items: left;
  flex-direction: column;
  padding-left: 10px;
  font-size: 14px;
  font-weight: 400;
  margin-right: 10px;
  color: ${(props) => props.color};
`;

const StyledMultipleListItemSlider = styled.div`
  flex-basis: 50%;
`;

export {
  StyledMultipleListChartWrapper,
  StyledMultipleListChartSvg,
  StyledMultipleListChartContent,
  StyledMultipleListChartMetric,
  StyledMultipleListItem,
  StyledMultipleListItemContent,
  StyledMultipleListItemTitle,
  StyledMultipleListItemValue,
  StyledMultipleListItemSlider
};
